export const CLAIM_CURRENCY_INPUT_WIDTH = "36ch";
